import React, { memo, useMemo } from 'react'

import useDisabledSelector from 'Pods/ThreeDStudio/Hooks/useDisabledSelector'
import ButtonGroupSelector from 'Pods/ThreeDStudio/Shared/ButtonGroupSelector/ButtonGroupSelector'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setMaterial } from 'Pods/ThreeDStudio/Store/actions/modelSettings'
import { MATERIAL } from 'Pods/ThreeDStudio/Store/constants'

const handlePbrClick = () => setMaterial(MATERIAL.PBR)
const handleBasicClick = () => setMaterial(MATERIAL.BASIC)
const handleGeometryOnlyClick = () => setMaterial(MATERIAL.GEOMETRY_ONLY)

function MaterialSelector() {
  const isSmartLowPoly = useThreeDStudioStore(state => state.modelSettings.isSmartLowPoly)
  const { isFullyDisabled, disabledValues } = useDisabledSelector('material', 'generationModelSchema')

  const buttons = useMemo(() => [
    {
      id: MATERIAL.PBR,
      label: 'PBR',
      onClick: handlePbrClick,
      disabled: isSmartLowPoly || isFullyDisabled || disabledValues.includes(MATERIAL.PBR),
    },
    {
      id: MATERIAL.BASIC,
      label: 'Basic',
      onClick: handleBasicClick,
      disabled: isSmartLowPoly || isFullyDisabled || disabledValues.includes(MATERIAL.BASIC),
    },
    {
      id: MATERIAL.GEOMETRY_ONLY,
      label: 'Geometry only',
      onClick: handleGeometryOnlyClick,
      disabled: isSmartLowPoly || isFullyDisabled || disabledValues.includes(MATERIAL.GEOMETRY_ONLY),
    },
  ], [isSmartLowPoly, isFullyDisabled, disabledValues])

  return (
    <ButtonGroupSelector
      buttons={buttons}
      keyName="material"
      sliceName="modelSettings"
      label="Material"
    />
  )
}

export default memo(MaterialSelector)
